import { render, staticRenderFns } from "./GrayPublishDialog.vue?vue&type=template&id=59995528&scoped=true&"
import script from "./GrayPublishDialog.vue?vue&type=script&lang=js&"
export * from "./GrayPublishDialog.vue?vue&type=script&lang=js&"
import style0 from "./GrayPublishDialog.vue?vue&type=style&index=0&id=59995528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59995528",
  null
  
)

export default component.exports